export interface AdminOwnerDailyAnalyticsPoint {
  date: string;
  ownerArchiveViews: number;
  ownerSessions: number;
  activeOwnerArchives: number;
  available: boolean;
}

export interface AdminOwnerAnalyticsPeriod {
  ownerArchiveViews: number;
  activeOwnerArchives: number;
}

export interface AdminOwnerDailyAnalyticsData {
  from: string;
  to: string;
  timeZone: string;
  firstOwnerActivityDate: string | null;
  lastAggregatedAt: string | null;
  period: AdminOwnerAnalyticsPeriod;
  daily: AdminOwnerDailyAnalyticsPoint[];
}

export interface AdminOwnerDailyAnalyticsResponse {
  data: AdminOwnerDailyAnalyticsData;
}

export interface AdminOwnerAnalyticsSummary {
  totalOwnerArchiveViews: number;
  periodActiveOwnerArchives: number;
  averageDailyActiveOwnerArchives: number;
  peakDailyActiveOwnerArchives: number;
}

const average = (values: number[]): number => {
  if (values.length === 0) return 0;
  return values.reduce((sum, value) => sum + value, 0) / values.length;
};

export const calculateAdminOwnerAnalyticsSummary = (
  data: AdminOwnerDailyAnalyticsData,
): AdminOwnerAnalyticsSummary => {
  const availableDays = data.daily.filter((day) => day.available);
  const dailyActiveOwnerArchives = availableDays.map(
    (day) => day.activeOwnerArchives,
  );

  return {
    totalOwnerArchiveViews: data.period.ownerArchiveViews,
    periodActiveOwnerArchives: data.period.activeOwnerArchives,
    averageDailyActiveOwnerArchives: average(dailyActiveOwnerArchives),
    peakDailyActiveOwnerArchives: Math.max(0, ...dailyActiveOwnerArchives),
  };
};
